import React from "react";
import { Quote } from "lucide-react";

/**
 * The public testimonial ribbon rendered on Landing.jsx when a visitor
 * arrives via `?ref=CODE`. Extracted so the Partner picker can preview
 * the exact same visual before publishing — no "rambling first take"
 * surprises after publish.
 *
 * Props: name (string), quote (string), variant "landing" | "preview"
 */
export function PartnerTestimonialRibbon({ name, quote, variant = "landing" }) {
  const testid =
    variant === "preview" ? "partner-testimonial-preview" : "partner-testimonial-ribbon";
  return (
    <div
      data-testid={testid}
      className={
        variant === "preview"
          ? "border-l-2 border-terracotta pl-5 sm:pl-6 py-2 bg-obsidian-900/40"
          : "mt-10 sm:mt-12 max-w-2xl border-l-2 border-terracotta pl-5 sm:pl-6 py-2 animate-fade-up"
      }
    >
      <p className="font-sans uppercase tracking-[0.22em] text-[0.6rem] text-terracotta mb-3 flex items-center gap-2">
        <Quote className="h-3 w-3" />
        A note from {name}
      </p>
      <blockquote className="font-serif italic text-lg sm:text-xl text-bone-100 leading-relaxed">
        "{quote}"
      </blockquote>
      <p className="mt-3 font-sans text-[0.65rem] uppercase tracking-[0.22em] text-bone-500">
        Chapter 1 · Answered aloud, unedited.
      </p>
    </div>
  );
}
